import styles from './MyOCLogin2018.module.css';

interface LoadingSpinnerProps {
  label?: string;
}

/**
 * CSS spinner replacing the legacy widget's `spinner.png` (avoids carrying a binary asset through the
 * package build for a trivial loading indicator). The legacy widget hardcoded "Loading...", so the
 * label defaults to that rather than requiring a (non-existent) AUTH_LOADING label key.
 */
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ label = 'Loading…' }) => (
  <div className={styles.loadingSpinner} data-testid="myoc-auth-spinner">
    <span className={styles.spinner} />
    <div>{label}</div>
  </div>
);

export default LoadingSpinner;
